import { IPublicClientApplication } from '@azure/msal-browser';
import { dvList, dvCreate } from '../api/dataverseClient';
import { Comment, CommentEntityType } from '../types';

const COMMENT_FIELDS = [
  'dagrun_pm_commentid',
  'dagrun_pm_name',
  'dagrun_pm_body',
  'dagrun_pm_authorid',
  'dagrun_pm_authorname',
  'dagrun_pm_entityid',
  'dagrun_pm_entitytype',
  'dagrun_pm_isdeleted',
  'dagrun_pm_isedited',
  'dagrun_pm_isaigenerated',
  'createdon',
];

export async function getTaskComments(
  pca: IPublicClientApplication,
  taskId: string,
): Promise<Comment[]> {
  return dvList<Comment>(pca, 'dagrun_pm_comments', {
    select: COMMENT_FIELDS,
    filter: `dagrun_pm_entityid eq '${taskId}' and dagrun_pm_entitytype eq ${CommentEntityType.Task} and dagrun_pm_isdeleted eq false`,
    orderby: 'createdon asc',
  });
}

export async function createTaskComment(
  pca: IPublicClientApplication,
  taskId: string,
  authorId: string,
  authorName: string,
  body: string,
  projectId?: string,
): Promise<string> {
  const preview = body.length > 80 ? body.slice(0, 77) + '…' : body;
  const data: Record<string, unknown> = {
    dagrun_pm_name: preview,
    dagrun_pm_body: body,
    dagrun_pm_authorid: authorId,
    dagrun_pm_authorname: authorName,
    dagrun_pm_entityid: taskId,
    dagrun_pm_entitytype: CommentEntityType.Task,
    dagrun_pm_isdeleted: false,
    dagrun_pm_isedited: false,
    dagrun_pm_isaigenerated: false,
    dagrun_pm_threaddepth: 0,
  };
  if (projectId) data.dagrun_pm_projectiddenorm = projectId;
  return dvCreate(pca, 'dagrun_pm_comments', data);
}
